import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

class ProductFeatures {
  constructor(root) {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    this.root = root;
    this.images = [...this.root.querySelectorAll('.ProductFeatures img')];
    this._init();
  }

  _init() {
    this.images.forEach((img) => {
      tippy(img, {
        content: img.dataset.tippy,
        // trigger: 'click',
      });
    });
  }
}

[...document.querySelectorAll('.ProductFeatures')].forEach((node) => {
  new ProductFeatures(node);
});